
import './App.css';
//import UilReact from '@iconscout/react-unicons/icons/uil-react'
import Topbuttons from './components/Topbuttons';
import Inputs from './components/Inputs';
import TimeAndlocation from './components/TimeAndlocation';
import Temperature from './components/Temperature';
import Forecast from './components/Forecast'
import getFormattedWeatherData from './service/Weatherservice';
import { useState,useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import getWeatherData from './service/Weatherservice';
function App() {
  const [query,setQuery]= useState({q:"chennai"});
  const [units, setUnits] = useState("imperial");
  const [weather, setWeather] = useState(null);
useEffect(() => {
  const fetchweatherdata= async()=>{
    const message=query.q?query.q:"current loaction.";
    toast.info("fetching data for "+message);
    const data=await getFormattedWeatherData({...query,units}).then((data)=>{
      
      toast.success(`Successfully fetched data for ${data.name} ${data.country}`)
      setWeather(data);
    });
    console.log(data);
  };
  console.log("hello world");
  fetchweatherdata();
  }, [query,units])

  const handlebackground=()=>{
    const optimum=units==="metric"?20:60;
    if(weather<=optimum){
      return " from-cyan-700 to-blue-700 shadow-xl shadow-gray-400"
    }
    return "from-yellow-600 to-red-800 shadow-xl shadow-grey-400"
  }
  
  return (
    <div className={`mx-auto max-w-screen-md mt-4 py-5 px-32 bg-gradient-to-br h-fit from-cyan-700 to-blue-700 shadow-xl shadow-gray-400  ${handlebackground()}`}>
      <Topbuttons setQuery={setQuery}/>
      <Inputs setQuery={setQuery} units={units} setUnits={setUnits}/>
 {weather &&(
    <div>
      <TimeAndlocation gaurav={weather}/>
      <Temperature  weather={weather}/>
      <Forecast title="Hourly forecast" items={weather.hourly}/>
      <Forecast title="Daily forecast"  items={weather.daily}/>
    </div>
       )}
      <ToastContainer autoClose={5000} position="top-right" newestOnTop={true} theme="colored"/>
    </div>
  );
}

export default App;
